const base_url = 'https://proweaveremail.com/shopifysendingemail/';
// test email
const test_email = true;

const company_name = 'Proweaver Shopify Template';

const company_email = 'professionalshopifytempate@gmail.com';

const email = test_email ? 'prospteam@gmail.com' : company_email;
$(document).on('submit', '#sp_form', function (e) {
    e.preventDefault();
    // if (grecaptcha.getResponse() === "" && $(this).attr('form-name') != 'Send Us A Message') {
    //     alert("Please verify that you are not a robot!");
    //     return false; // prevent form submission
    // }

    const formdata = new FormData($(this)[0]);
    const form_name = `${company_name} | ${$(this).attr('form-name')}`;

    formdata.append('form_name', form_name);
    formdata.append('company_name', company_name);
    formdata.append('email', email);

    $.ajax({
        url: base_url,
        type: 'POST',
        data: formdata,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (response) {
            $('#prompt_message').html(response.message);

            $(`#sp_form button[type='submit']`).prop('disabled', true);
        }
    })
});